import StudentAPI from "../apis/StudentAPI";
import AlertService from "./AlertService";
import { createAndDownloadBlobFile, base64ToArrayBuffer } from "../utilities/FileUtility";

class InterviewService {
  async getInterviewDetails(uuid) {
    try {
      const resp = await StudentAPI.get("interview/GetInterview/" + uuid);
      return resp.data;
    } catch (err) {}
  }

  async getAllQuestionChoices() {
    try {
      const resp = await StudentAPI.get("questionChoice/GetAllQuestionChoices/");
      return resp.data;
    } catch (err) {}
  }

  async addQuestionChoice(questionChoice) {
    try {
      const resp = await StudentAPI.post("questionChoice", questionChoice);
      AlertService.addSuccessAlert("Question choice was successfully added");
      return resp.data.id;
    } catch (err) {
      AlertService.addErrorAlert(
        "There was a problem adding the question choice"
      );
    }
  }

  async addInterviewType(interviewType) {
    try {
      const resp = await StudentAPI.post("interviewType", interviewType);
      AlertService.addSuccessAlert("Interview type was successfully added");
      return resp.data.id;
    } catch (err) {
      AlertService.addErrorAlert(
        "There was a problem with submitting the interview type"
      );
    }
  }

  async addInterviewStep(interviewStep) {
    try {
      const resp = await StudentAPI.post("interviewStep", interviewStep);
      AlertService.addSuccessAlert("Interview step was successfully added");
      return resp.data.id;
    } catch (err) {
      AlertService.addErrorAlert(
        "There was a problem with add the interview step"
      );
    }
  }

  async addInterviewQuestion(interviewQuestion) {
    try {
      // add the question
      const resp = await StudentAPI.post(
        "interviewQuestion",
        interviewQuestion
      );
      AlertService.addSuccessAlert("Interview question was successfully added");
      interviewQuestion.id = resp.data.id;
      interviewQuestion.interviewQuestionID = resp.data.id;

      // add a link between the question and the new step
      await StudentAPI.post("stepQuestionLink", interviewQuestion);
      return resp.data.id;
    } catch (err) {
      AlertService.addErrorAlert(
        "There was a problem with add the interview step"
      );
    }
  }

  async addInterviewEvent(intterviewEvent) {
    try {
      // add the question
      const resp = await StudentAPI.post("interviewEvent", intterviewEvent);
      AlertService.addSuccessAlert("Interview event was successfully added");
      intterviewEvent.id = resp.data.id;
      return resp.data.id;
    } catch (err) {
      AlertService.addErrorAlert(
        "There was a problem with adding the interview event"
      );
    }
  }

  async submitCRInterviewTemplate(interviewTemplate) {
    try {
      const resp = await StudentAPI.post(
        "interview/SaveInterviewTemplate",
        interviewTemplate
      );
      AlertService.addSuccessAlert("Interview was successfully added");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(
        "There was a problem with submitting the interview"
      );
    }
  }

  async updateCRInterviewTemplate(interviewTemplate) {
    if (interviewTemplate.id === 0) {
      AlertService.addErrorAlert(
        "You can not update an interview that has not yet been created"
      );
    } else {
      try {
        const resp = await StudentAPI.post(
          "interview/updateInterviewTemplate",
          interviewTemplate
        );
        AlertService.addSuccessAlert("Interview was successfully updated");
        return resp.data;
      } catch (err) {
        AlertService.addErrorAlert(
          "There was a problem with updating the interview"
        );
      }
    }
  }

  async deleteCRInterviewTemplate(interviewTemplateid) {
    if (interviewTemplateid === 0) {
      AlertService.addErrorAlert(
        "You can not delete an interview that has not yet been created"
      );
    } else {
      try {
        const resp = await StudentAPI.delete(
          "interview/deleteInterviewTemplate/" + interviewTemplateid
        );
        AlertService.addSuccessAlert("Interview was successfully deleted");
        return resp.data;
      } catch (err) {
        AlertService.addErrorAlert(
          "There was a problem with deleting the interview"
        );
      }
    }
  }

  async submitInterviewTemplate(interviewTemplate) {
    try {
      const resp = await StudentAPI.post(
        "interview/SaveInterviewTemplate",
        interviewTemplate
      );
      AlertService.addSuccessAlert("Interview was successfully added");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(
        "There was a problem with submitting the interview"
      );
    }
  }

  async updateInterviewTemplate(interviewTemplate) {
    if (interviewTemplate.id === 0) {
      AlertService.addErrorAlert(
        "You can not update an interview that has not yet been created"
      );
    } else {
      try {
        const resp = await StudentAPI.post(
          "interview/updateInterviewTemplate",
          interviewTemplate
        );
        AlertService.addSuccessAlert("Interview was successfully updated");
        return resp.data;
      } catch (err) {
        AlertService.addErrorAlert(
          "There was a problem with updating the interview"
        );
      }
    }
  }
  async deleteInterviewTemplate(interviewTemplateid) {
    if (interviewTemplateid === 0) {
      AlertService.addErrorAlert(
        "You can not delete an interview that has not yet been created"
      );
    } else {
      try {
        const resp = await StudentAPI.delete(
          "interview/deleteInterviewTemplate/" + interviewTemplateid
        );
        AlertService.addSuccessAlert("Interview was successfully deleted");
        return resp.data;
      } catch (err) {
        AlertService.addErrorAlert(
          "There was a problem with deleting the interview"
        );
      }
    }
  }

  async searchStudentInterviewLink(parameters) {
    try {
      const resp = await StudentAPI.post(
        "studentInterviewLink/search",
        parameters
      );
      return resp.data;
    } catch (err) {}
  }

  async getNextStep(studentInterviewLinkId, stepId, answers, aidYear) {
    try {
      const resp = await StudentAPI.post("interview/getInterviewStep", {
        StudentInterviewLinkID: studentInterviewLinkId,
        InterviewStepID: stepId,
        Answers: answers,
        AidYear: aidYear
      });
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(
        "There was a problem with retrieving the next interview step"
      );
    }
  }

  async getAllInterviewTypes() {
    try {
      const resp = await StudentAPI.get("interviewType/");
      return resp.data;
    } catch (err) {}
  }

  async getAllInterviewTypesWithRevisions(aidYear) {
    try {
      const resp = await StudentAPI.get("interviewType/GetAllWithRevisions?aidYear=" + aidYear);
      return resp.data;
    } catch (err) {}
  }

  async getFilteredInterviewTypes(searchParameters) {
    try {
      const resp = await StudentAPI.post(
        "interview/getFilteredInterviewTypes",
        {
          ...searchParameters,
        }
      );
      return resp.data;
    } catch (err) {}
  }

  async getInterviewType(id) {
    try {
      const resp = await StudentAPI.get("interviewType/" + id);
      return resp.data;
    } catch (err) {}
  }

  async getInterviewTypeWithRevisions(id, aidYear) {
    try {
      const resp = await StudentAPI.get(`interviewType/GetOneWithRevisions/${id}?aidYear=${aidYear}`);
      return resp.data;
    } catch (err) {}
  }

  async createStudentInterviewLink(
    studentId,
    interviewCode,
    isForParentAccount,
    questionText
  ) {
    try {
      const resp = await StudentAPI.post(
        "studentinterviewlink/createStudentInterviewLink",
        {
          StudentID: studentId,
          TypeCode: interviewCode,
          IsForParentAccount: isForParentAccount,
          QuestionText: questionText,
        }
      );
      return resp.data;
    } catch (err) {}
  }

  async saveUploadStudentInterviewLink(
    fileID,
    alfrescoID,
    fileName,
    questionID,
    studentInterviewLinkID,
    versionID
  ) {
    try {
      const resp = await StudentAPI.post(
        "interview/saveUploadStudentInterviewLink",
        {
          FileName: fileName,
          FileID: fileID,
          AlfrescoID: alfrescoID,
          StudentInterviewLinkID: studentInterviewLinkID,
          QuestionID: questionID,
          VersionID: versionID
        }
      );
      return resp.data;
    } catch (err) {}
  }

  async searchInterviewType(interviewType) {
    try {
      const resp = await StudentAPI.post("interviewType/search", interviewType);
      return resp.data;
    } catch (err) {}
  }

  async resetInterview(studentInterviewLInkID, questionText) {
    try {
      let resp = undefined;
      if (questionText) {
        resp = await StudentAPI.post(
          `interview/ResetInterview/${studentInterviewLInkID}`, questionText, {
            headers: { "Content-Type": "application/json" }
        });
      } else {
        resp = await StudentAPI.get(
          `interview/ResetInterview/${studentInterviewLInkID}`
        );
      }
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Reset failed");
      return false;
    }
  }

  async getInterviewHistory(studentInterviewLInkID) {
    try {
      const resp = await StudentAPI.get(
        `InterviewAttempt/InterviewHistory/${studentInterviewLInkID}`
      );
      return resp.data;
    } catch (err) {}
  }

  async getStudentInterviewHistory(uuid) {
    try {
      const resp = await StudentAPI.get(
        `StudentInterviewLink/StudentInterviewHistory/${uuid}`
      );
      return resp.data;
    } catch (err) {}
  }

  async getStudentParameters(studentID) {
    try {
      const resp = await StudentAPI.get(
        `interview/getStudentParameters/${studentID}`
      );
      return resp.data;
    } catch (err) {}
  }

  async getAlfrescoDocument(id) {
    try {
      const resp = await StudentAPI.get(`AlfrescoDocument/${id}`);
      return resp.data;
    } catch (err) {}
  }

  async downloadLink(alfrescoID, fileID, fileName, studentID, documentType, interviewTypeID, versionID) {
    try {
      const resp = await StudentAPI.post("interview/fileDownload/", {
        alfrescoID: alfrescoID,
        fileID: fileID,
        fileName: fileName,
        studentID: studentID,
        documentType: documentType,
        interviewTypeID: interviewTypeID,
        versionID: versionID
      });
      const arrayBuffer = base64ToArrayBuffer(resp.data);
      createAndDownloadBlobFile(arrayBuffer, `${versionID} ${fileName}`);
      return arrayBuffer;
    } catch (err) {
      AlertService.addErrorAlert("Download failed");
      return null;
    }
  }

  async downloadLinksByStudentInterviewLinkID(studentInterviewLink, isUpload, processorDocuments) {
    try {
      let parameters = {"StudentInterviewLink": studentInterviewLink,
                        "ProcessorDocuments": processorDocuments};
      const resp = await StudentAPI.post(`interview/downloadManyFilesByStudentInterviewLinkID/${isUpload}`, parameters);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Downloads failed");
      return null;
    }
  }

  async deleteAlfrescoDocument(id) {
    try {
      const resp = await StudentAPI.delete(`interview/deleteAlfrescoDocument/${id}`);
      return resp.data;
    } catch (err) {}
  }

  async saveIdentityVerifyInterviewAttempt(
    studentInterviewLinkID,
    attemptAnswer,
    questionText
  ) {
    try {
      const resp = await StudentAPI.post(
        "interview/SaveIdentityVerifyInterviewAttempt/",
        {
          StudentInterviewLinkID: studentInterviewLinkID,
          attemptAnswer: attemptAnswer,
          questionText: questionText,
        }
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Update failed");
      return false;
    }
  }

  async getAllAidYearInterviewTypeLinks() {
    try {
      const resp = await StudentAPI.get("aidYearInterviewTypeLink/");
      return resp.data;
    } catch (err) {}
  }

  async searchInterviewSteps(interviewTypeID) {
    try {
      const resp = await StudentAPI.post('interviewStep/search', {
        interviewTypeID: interviewTypeID  
      });
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Interview step search failed");
    }
  }

  async searchStepQuestionLinks(interviewStepID) { 
    try {
      const resp = await StudentAPI.post('stepQuestionLink/search', {
        interviewStepID: interviewStepID
      });
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Step question link search failed");
    }
  }
}

let instance = new InterviewService();
export default instance;
